import React from 'react';
import { 
  BottomNavigation, 
  BottomNavigationAction, 
  Paper, 
  Fab,
  useTheme
} from '@mui/material';
import { 
  Home as HomeIcon, 
  Search as SearchIcon, 
  QueueMusic as PlaylistsIcon, 
  Chat as ChatIcon,
  Add as AddIcon,
  Headphones as HeadphonesIcon
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';

interface MobileNavigationProps {
  onAddPlaylistClick?: () => void;
}

const MobileNavigation: React.FC<MobileNavigationProps> = ({ onAddPlaylistClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  
  // Get the current path without the leading slash
  const currentPath = location.pathname.substring(1);
  
  // Map paths to values for BottomNavigation
  const pathToValue: Record<string, number> = {
    'home': 0,
    'search': 1,
    'playlists': 2,
    'ai': 3,
    'dj-playlist': 4,
  };
  
  // Default to home if path is not in the map
  const currentValue = pathToValue[currentPath] !== undefined ? pathToValue[currentPath] : 0;
  
  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    // Map values back to paths
    const paths = ['home', 'search', 'playlists', 'ai', 'dj-playlist'];
    navigate(`/${paths[newValue]}`);
  };
  
  return (
    <>
      {/* Floating Action Button for adding playlists */}
      {currentPath === 'playlists' && (
        <Fab 
          color="primary" 
          aria-label="add playlist" 
          className="mobile-fab"
          onClick={onAddPlaylistClick}
          sx={{
            position: 'fixed',
            bottom: 76,
            right: 16,
            zIndex: theme.zIndex.drawer + 2
          }}
        >
          <AddIcon />
        </Fab>
      )}
      
      {/* Bottom Navigation */}
      <Paper 
        sx={{ 
          position: 'fixed', 
          bottom: 0, 
          left: 0, 
          right: 0,
          zIndex: theme.zIndex.drawer + 1
        }} 
        elevation={3}
        className="mobile-bottom-nav"
      >
        <BottomNavigation
          showLabels
          value={currentValue}
          onChange={handleChange}
        >
          <BottomNavigationAction label="Home" icon={<HomeIcon />} />
          <BottomNavigationAction label="Search" icon={<SearchIcon />} />
          <BottomNavigationAction label="Playlists" icon={<PlaylistsIcon />} />
          <BottomNavigationAction label="AI Chat" icon={<ChatIcon />} />
          <BottomNavigationAction label="DJ Mix" icon={<HeadphonesIcon />} />
        </BottomNavigation>
      </Paper>
    </>
  );
};

export default MobileNavigation;
